import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'audCurrency',
  standalone: false
})
export class AudCurrencyPipe implements PipeTransform {

  transform(value: number, currencyCode: string, locale?: string): string {
    const symbol = getCurrencySymbol(currencyCode, 'narrow', locale);
    return `${symbol}${value.toFixed(2)}`;
  }

}
